__turbopack_context__.v({
  "caret": "Header-module__gGZkwq__caret",
  "caret-blink": "Header-module__gGZkwq__caret-blink",
  "content": "Header-module__gGZkwq__content",
  "copyCollapsed": "Header-module__gGZkwq__copyCollapsed",
  "ctaRow": "Header-module__gGZkwq__ctaRow",
  "eyebrow": "Header-module__gGZkwq__eyebrow",
  "headerContainer": "Header-module__gGZkwq__headerContainer",
  "hero-drift": "Header-module__gGZkwq__hero-drift",
  "hero-grid-drift": "Header-module__gGZkwq__hero-grid-drift",
  "hero-image-drift": "Header-module__gGZkwq__hero-image-drift",
  "hero-orbit": "Header-module__gGZkwq__hero-orbit",
  "heroCopy": "Header-module__gGZkwq__heroCopy",
  "heroSide": "Header-module__gGZkwq__heroSide",
  "logo-edge-breathe-lower": "Header-module__gGZkwq__logo-edge-breathe-lower",
  "logo-edge-breathe-upper": "Header-module__gGZkwq__logo-edge-breathe-upper",
  "logo-edge-draw": "Header-module__gGZkwq__logo-edge-draw",
  "logo-edge-glint": "Header-module__gGZkwq__logo-edge-glint",
  "logo-edge-halo": "Header-module__gGZkwq__logo-edge-halo",
  "logoEdge": "Header-module__gGZkwq__logoEdge",
  "logoEdgeDesktop": "Header-module__gGZkwq__logoEdgeDesktop",
  "logoEdgeGlint": "Header-module__gGZkwq__logoEdgeGlint",
  "logoEdgeHalo": "Header-module__gGZkwq__logoEdgeHalo",
  "logoEdgeLower": "Header-module__gGZkwq__logoEdgeLower",
  "logoEdgeLowerMobile": "Header-module__gGZkwq__logoEdgeLowerMobile",
  "logoEdgeMobile": "Header-module__gGZkwq__logoEdgeMobile",
  "logoEdgePath": "Header-module__gGZkwq__logoEdgePath",
  "logoEdgeUpper": "Header-module__gGZkwq__logoEdgeUpper",
  "logoEdgeUpperMobile": "Header-module__gGZkwq__logoEdgeUpperMobile",
  "logoEdges": "Header-module__gGZkwq__logoEdges",
  "primaryButton": "Header-module__gGZkwq__primaryButton",
  "primaryHeading": "Header-module__gGZkwq__primaryHeading",
  "reveal-up": "Header-module__gGZkwq__reveal-up",
  "scrollButton": "Header-module__gGZkwq__scrollButton",
  "secondaryButton": "Header-module__gGZkwq__secondaryButton",
  "subHeading": "Header-module__gGZkwq__subHeading",
  "titleAccent": "Header-module__gGZkwq__titleAccent",
  "titleLead": "Header-module__gGZkwq__titleLead",
  "titleMeasure": "Header-module__gGZkwq__titleMeasure",
  "typedGhost": "Header-module__gGZkwq__typedGhost",
  "typedOverlay": "Header-module__gGZkwq__typedOverlay",
  "visual": "Header-module__gGZkwq__visual",
  "visualImage": "Header-module__gGZkwq__visualImage",
});
